import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withMainLayout } from "../view/LayoutHOCs";
import * as layoutService from "../view/layoutService";
import { InfoBoxes } from "../info-boxes/InfoBoxes";
import UsersTableSection from "./UsersTableSection";
import AuthServerTableSection from "./authserver/AuthServerTableSection";
import CentralCredentialsTableSection from "./centralcredentials/CentralCredentialsTableSection";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Authentication",
        redirectTo: "/auth",
    }
]


function AuthenticationPage({ userCapability }) {

    useEffect(() => {
        layoutService.setPageTitle('Authentication');
        layoutService.setBreadcrumbs(breadcrumbs);
    }, []);

    //#region Set User Capabilities
    const checkAuthenticationCapability = async () => {
        try {
            if (userCapability) {
                const capability = userCapability.find(item =>
                    item.component === "authentication" && item.type === "page")?.permission;
                if (capability === -1) {
                    sessionStorage.removeItem('access_token');
                    window.location.reload();
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        checkAuthenticationCapability();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion      

    return (
        <>
            <InfoBoxes />
            <UsersTableSection />
            <AuthServerTableSection />
            <CentralCredentialsTableSection />
        </>
    )

}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default withMainLayout(connect(mapStateToProps)(AuthenticationPage));